<div class="wrapper">
  <mat-icon aria-hidden="false" fontIcon="description" class="font-icon menu-icon"></mat-icon>
  <span>Beschreibungen anzeigen</span>

  <mat-slide-toggle
    [formControl]="descriptionsVisibleFormControl"
    class="eFormsSlider"
    matTooltip="Beschreibungen anzeigen/ausblenden"
    aria-label="Beschreibungen anzeigen/ausblenden">
  </mat-slide-toggle>
</div>
